import functions from './functions.js';
import Slider from "./components/Slider.js";
import { details } from './details';

$(() => {
    detailsCamps.init();

    // Independent of detailsCamps.init()'s booking-flow chain on purpose -
    // this has no dependency on objectId/departures/etc., and shouldn't go
    // dark just because something earlier in that chain throws (e.g. no
    // pricelist data on a given page).
    //
    // requestAnimationFrame, not called directly: theme-slider.js (imported
    // before this file, so its ready handler runs first) constructs the
    // .activities-body Slider synchronously, but keen-slider's own slide
    // sizing/positioning is itself applied via requestAnimationFrame, not
    // inside that constructor call - so right here, the slides are still
    // unlaid-out (all full-width in the same row). Requesting our own frame
    // queues us after keen-slider's already-pending one, so this runs once
    // the real per-slide layout is in place instead of measuring the
    // pre-layout, cramped state.
    requestAnimationFrame(() => {
        detailsCamps.initActivitiesSummaryHeight();
    });
});

const detailsCamps = {
    $details: null,
    $form: null,
    form: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: '1,0',
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        partnerId: null,
        calcErrorMessages: null,
    },
    $guests: null,
    $selectedDateFrom: null,
    $selectedDateTo: null,
    $dateFrom: null,
    $dateTo: null,
    $dateFromDay: null,
    $dateToDay: null,
    init() {
        this.$details = $('.page-mars-details');

        if(! this.$details.length) {
            return;
        }

        this.params.objectId = this.$details.attr('data-objectId');
        
        if(! this.params.objectId) {
            return;
        }
        
        this.params.objectGroupId = this.$details.attr('data-objectGroupId');
        this.params.partnerId = this.$details.attr('data-partnerId');

        this.$guests = $('[name="guests"]');

        this.$selectedDateFrom = $('.selected-date-from');
        this.$selectedDateTo = $('.selected-date-to');

        this.$dateFrom = this.$selectedDateFrom.find('.date');
        this.$dateTo = this.$selectedDateTo.find('.date');

        this.$dateFromDay = this.$selectedDateFrom.find('.week-day');
        this.$dateToDay = this.$selectedDateTo.find('.week-day');
        
        this.getParams();

        this.setDefaultGuests();
        
        this.initDepartureCalendar();
        this.setDefaultDeparture();

        this.getCalculation();

        // Scoped to #booking - hero_gallery.blade.php renders its own preview
        // .departure pills (date only, data-scroll-to, no data-rates) earlier
        // in the DOM; an unscoped selector picks those up first and their
        // missing data-rates silently breaks setPricesFromRates().
        $('#booking .departure').on('click', e => {
            $('#booking .departure').removeClass('active');

            const $target = $(e.currentTarget);
            $target.addClass('active');
            this.params.dateFrom = $target.attr('data-datefrom');
            $('#booking [data-datefrom=' + this.params.dateFrom + ']').addClass('active');
            this.params.dateTo = $target.attr('data-dateto');

            this.setPricesFromRates($target);

            this.printDates();

            functions.setUrlData({'dateFrom': this.params.dateFrom, 'guests': this.params.guests }, true, true);
        });

        this.$guests.on('change', e => {
            e.preventDefault();
            const $target = $(e.currentTarget);
            this.params.guests = $target.val();

            functions.setUrlData({'dateFrom': this.params.dateFrom, 'guests': this.params.guests }, true, true);
        });

        $(window).on('hashchange', e => {
            this.getParams();

            this.getCalculation();
        });
    },
    // Instant feedback from the rates already inlined on the departure slide
    // (departures.blade.php's data-rates) - getCalculation() still fires
    // (on click via the hashchange listener, on load via init()) and
    // overwrites this with the server-calculated total once it resolves.
    setPricesFromRates($departure) {
        const rates = $departure.data('rates') || {};
        Object.entries(rates).forEach(([unitId, rate]) => {
            $('.unit[data-unitid=' + unitId + ']').find('.unit-price-total').text(rate.price);
        });
    },
    getParams() {
        this.params = details.getParams(this.params);
    },
    getCalculation() {
        
        const calculation = details.getCalculation(this.params);
        //this.setUnitRates();
        if(calculation) {
            //this.loader(this.params.unitId ? $('.unit[data-unitid=' + this.params.unitId + ']').find('.unit-spinner') : null);
            //this.loadSpinner(this.params.unitId ? $('.unit[data-unitid=' + this.params.unitId + ']').find('.unit-spinner') : null);
            calculation
                .done(response => {
                    this.calculationDone(response);
                }).fail(error => {
                    console.log(error);
                });
        } else {

            //this.setPrices($('.departure[data-datefrom=' + this.params.dateFrom + '][data-dateto=' + this.params.dateTo + ']'));

            //this.setUnitRates();
            
            //$('.send-request-link').toggleClass('d-none', true);

            //$('.unit-error-container').toggleClass('d-none', true);

            //$('.unit-price-payment-key').toggleClass('d-none', false);

            $('.btn-booking').addClass('d-none');
        }
    },
    calculationDone(response) {
        if(response.status) {
            const data = response.data || [];

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                const unitCalc = unitData.calc;
                const $unit = $('.unit[data-unitid=' + unitId + ']');
                
                let discountTitle = null;
                let isBookable = details.isBookable(unitData);
                if (this.params.partnerId != 30364) isBookable = true;
                if(unitCalc && unitCalc.total) {
                    
                    if(isBookable) {
                        const calcItems = unitCalc.items;
                        const currencySymbol = unitCalc.currencySymbol;
                        
                        let total = unitCalc.total;
    
                        let priceOld = details.getCalcTotalOld(calcItems);
                        priceOld = +priceOld.toFixed(2);
    
                        discountTitle = details.getCalcDiscountTitle(calcItems);
        
                        if(discountTitle) {
                            $unit.find('.unit-price-discount-title').text(discountTitle);
                            $unit.find('.fm-discount-title').text(discountTitle ? discountTitle : '');
                        }
    
                        $unit.find('.unit-price-old').text(priceOld > total ? currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',') : '');
                        $unit.find('.unit-price-total-label').removeClass('d-none');
                        $unit.find('.unit-price-total').text(currencySymbol + ' ' + functions.formatMoney(total, 0, '.', ','));
    
                        const $btnBooking = $('.btn-booking[data-unitid=' + unitId + ']');

                        if($btnBooking.attr('data-href')) {
                            $btnBooking.attr('data-href',
                                $btnBooking.attr('data-href').split('?')[0] +
                                '?objectGroupId=' + this.params.objectGroupId +
                                '&unitId=' + unitId +
                                '&dateFrom=' + this.params.dateFrom +
                                '&dateTo=' + this.params.dateTo +
                                '&guests=1,0,0' +
                                '&partnerId=' + this.params.partnerId +
                                '&addAllOptionals=' + 1
                            );
                        }
    
                        $btnBooking.on('click', e => {
                            e.preventDefault();
                            location = $(e.currentTarget).attr('data-href');
                        });
                        
                    } else {
                        //$unit.prop('style', 'order: 10000;');
                    }
                }
                
                //$unit.find('.unit-price-total-label').toggleClass('d-none', ! details.isBookable(unitData));
                //$unit.find('.unit-price').toggleClass('d-none', ! details.isBookable(unitData));

                $unit.find('.unit-price-discount-title').toggleClass('d-none', ! isBookable);
                $unit.find('.unit-price-payment-key').toggleClass('d-none', isBookable);

                $unit.find('.fm-discount').toggleClass('d-none', ! discountTitle || ! isBookable);                
                $unit.find('.fm-discount-valid-until').toggleClass('d-none', isBookable);

                $unit.find('.btn-booking').toggleClass('d-none', ! isBookable);
                $unit.find('.send-request-link').toggleClass('d-none', ! isBookable);

                let error = details.getCalcErrorMessage(this.params.calcErrorMessages, unitData);
                
                $unit.find('.unit-error-container').toggleClass('d-none', isBookable);
                $unit.find('.unit-error-container').text(error);

                $unit.find('.no-period-label').toggleClass('d-none', unitData.message == 'notAvailable' || isBookable);
                $unit.find('.unit-price-label').toggleClass('d-none', unitData.message == 'notAvailable' || details.isBookable(unitData));

                if(! isBookable) {
                    $unit.find('.no-period-label').addClass('d-none');
                }
            });

        }
    },
    initDepartureCalendar() {
        const $bookingCalendar = $('#booking-calendar-slider');

        if($bookingCalendar[0]) {
            const length = $bookingCalendar.find('.keen-slider__slide').length;
            const perView = 8;
            
            let slidesPerView = length < perView ? length : perView;

            if(length < perView) {
                $('.booking-calendar-wrapper').addClass('col-lg-' + (slidesPerView + 2));
                //$('.booking-calendar-wrapper').addClass('col-auto');
                $('.booking-calendar-wrapper').addClass('mx-auto');
            }
    
            this.slider = new Slider($bookingCalendar, {
                // mode: 'snap',
                //centered: true,
                duration: 200,
                fade: false,
                loop: false,
                controls: false,
                initial: 0,
                arrows: functions.isMobile() || length > slidesPerView,
                slides: {
                    perView: slidesPerView,
                    spacing: 0,
                },
                breakpoints: {
                    '(min-width: 577px) and (max-width: 1024px)': {
                        controls: true,
                        arrows: length > 6,
                        //centered: true,
                        slides: {
                            perView: 6.2,
                        },
                    },
                    '(max-width: 576px)': {
                        controls: true,
                        arrows: length > 2,
                        //centered: true,
                        slides: {
                            perView: 2.2,
                        },
                    },
                },
            });
        }
    },
    // The shortest activity's own natural text height becomes the clamp
    // height for every card in that group (--activity-summary-height, read
    // by _details.scss's mobile-only .activity-summary rule). The 9rem
    // fallback clamp is already active on every card before this runs (it's
    // plain CSS, no JS needed), so height() would otherwise just read that
    // same clamped ~9rem for every card - setting max-height:none inline
    // (highest possible precedence, no class/specificity to get wrong) for
    // the single measurement pass makes height() report each card's true
    // natural height, then the inline override is removed so the CSS clamp
    // (now driven by the value just computed) takes back over.
    // ponytail: computed once on load, not on resize/orientation change -
    // add a debounced resize re-run if that turns out to matter in practice.
    initActivitiesSummaryHeight() {
        // _details.scss's clamp only exists below lg (media-breakpoint-down(lg)) -
        // at/above lg, .activity-images is d-lg-block (visible), so
        // .activity-text only gets its narrower col-lg share of the row and
        // wraps into far more lines than it would at true mobile width.
        // Measuring there produces a genuinely-tall-but-meaningless number
        // for a clamp that isn't even active at that width.
        if (window.innerWidth >= 992) {
            return;
        }

        $('.activities-body').each((i, body) => {
            const $summaries = $(body).find('.activity-summary');

            if (! $summaries.length) {
                return;
            }

            $summaries.css('max-height', 'none');
            const heights = $summaries.map((j, el) => {
                // debugger
                console.log($(el).height());
                return $(el).height()
            }).get();
            $summaries.css('max-height', '');

            const minHeight = Math.min(...heights);
            $(body).css('--activity-summary-height', minHeight + 'px');

            $summaries.each((j, el) => {
                $(el).next('[data-toggle-summary]').toggleClass('d-none', heights[j] <= minHeight);
            });
        });
    },
    setDefaultDeparture() {
        this.params.dateFrom = ! this.params.dateFrom ? $('#booking [data-datefrom]').attr('data-datefrom') : this.params.dateFrom;
        const $departure = $('#booking [data-datefrom=' + this.params.dateFrom + ']').addClass('active');
        this.params.dateTo = $departure.attr('data-dateto');

        this.params.guests = $('[name=guests]').val();

        functions.setUrlData({'dateFrom': this.params.dateFrom, 'guests': this.params.guests }, true, true);
        console.log($departure);
        this.setPricesFromRates($departure);

        this.printDates();
    },
    setDefaultGuests() {
        this.params.guests && this.$guests.val(this.params.guests).trigger('change');
    },
    printDates() {
        let dateFrom = this.params.dateFrom;
        let dateTo = this.params.dateTo;

        if(dateFrom && dateTo) {
            this.$dateFrom.text(functions.formatDate(dateFrom));
            this.$dateTo.text(functions.formatDate(dateTo));

            this.$dateFromDay.text(functions.getWeekday(dateFrom));
            this.$dateToDay.text(functions.getWeekday(dateTo));
        }
    }
}